import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditComponent } from './field-edit.component';
import { FormsModule } from '@angular/forms';
import { NbCardModule } from '@nebular/theme';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NgSelectModule
  ],
  declarations: [FieldEditComponent]
})
export class FieldEditModule { }



// WEBPACK FOOTER //
// ./src/app/components/field-edit/field-edit.module.ts